import Box from "@mui/material/Box";
import { useEffect, useRef } from "react";
import styles from "../DescriptionTabs.module.scss";
import { useTranslation } from "react-i18next";

const DescriptionTab = ({ description, declaration, translateKey }) => {
    const descText = useRef("");
    const { t } = useTranslation();

    useEffect(() => {
        if (description?.description && descText?.current) {
            descText.current.innerHTML = description.description;
        }
    }, []);

    const hasAtLeastOneDescription = Object.values(description).some((value) => value !== null && value !== "");
    const hasAtLeastOneDeclaration = Object.values(declaration).some((value) => value !== null && value !== "");

    if (!hasAtLeastOneDescription && !hasAtLeastOneDeclaration) {
        return <></>;
    }

    return (
        <>
            <Box className={styles.tabContent} sx={{ fontFamily: "Montserrat !important" }}>
                {hasAtLeastOneDescription && (
                    <>
                        <h6 className={styles.tabTitle}>{t(`${translateKey}-title`)}</h6>

                        <Box className={styles.tabSection}>
                            <>
                                {description?.description && (
                                    <p className={styles.specificationRow}>
                                        <span ref={descText}></span>
                                    </p>
                                )}
                                {description?.manufacture_name && (
                                    <p className={styles.specificationRow}>
                                        <span className={styles.specificationRowTitle}>{t(`${translateKey}-text-manufacturer`)}:</span>
                                        <span className={styles.specificationRowValue} dangerouslySetInnerHTML={{ __html: description?.manufacture_name }} />
                                    </p>
                                )}
                                {description?.brand_name && (
                                    <p className={styles.specificationRow}>
                                        <span className={styles.specificationRowTitle}>{t(`${translateKey}-text-brand`)}:</span>
                                        <span className={styles.specificationRowValue} dangerouslySetInnerHTML={{ __html: description?.brand_name }} />
                                    </p>
                                )}
                            </>
                            {!(description?.description || description?.manufacture_name || description?.brand_name) && <p>N/A</p>}
                        </Box>
                    </>
                )}
                {hasAtLeastOneDeclaration && (
                    <>
                        {declaration.name || declaration.year || declaration.importer_name || declaration.country_name || declaration.note ? (
                            <>
                                <h6 className={styles.tabTitle}>{t(`${translateKey}-text-declaration`)}</h6>
                                <Box className={styles.tabSection}>
                                    {declaration.name && (
                                        <p className={styles.specificationRow}>
                                            <span className={styles.specificationRowTitle}>{t(`${translateKey}-text-name`)}:</span>
                                            <span className={styles.specificationRowValue} dangerouslySetInnerHTML={{ __html: declaration.name }} />
                                        </p>
                                    )}

                                    {declaration.year && (
                                        <p className={styles.specificationRow}>
                                            <span className={styles.specificationRowTitle}>{t(`${translateKey}-text-production_year`)}:</span>
                                            <span className={styles.specificationRowValue}>{declaration.year}</span>
                                        </p>
                                    )}

                                    {declaration.importer_name && (
                                        <p className={styles.specificationRow}>
                                            <span className={styles.specificationRowTitle}>{t(`${translateKey}-text-importer`)}:</span>
                                            <span className={styles.specificationRowValue} dangerouslySetInnerHTML={{ __html: declaration.importer_name }} />
                                        </p>
                                    )}

                                    {declaration.country_name && (
                                        <p className={styles.specificationRow}>
                                            <span className={styles.specificationRowTitle}>{t(`${translateKey}-text-import_country`)}:</span>
                                            <span className={styles.specificationRowValue} dangerouslySetInnerHTML={{ __html: declaration.country_name }} />
                                        </p>
                                    )}

                                    {declaration.note && (
                                        <p className={styles.specificationRow}>
                                            <span className={styles.specificationRowTitle}>{t(`${translateKey}-text-note`)}:</span>
                                            <span className={styles.specificationRowValue} dangerouslySetInnerHTML={{ __html: declaration.note }} />
                                        </p>
                                    )}
                                </Box>
                            </>
                        ) : null}
                    </>
                )}
            </Box>
        </>
    );
};

export default DescriptionTab;
